import styled from 'styled-components';

const OuterWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.neutral.default};
`;

const Wrapper = styled.div`
  padding: 76px 0 68px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  background: url('${(props) => props.imageUrl}') no-repeat 295px 50%;
  background-size: cover;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 40px 0 56px;
    background: url('${(props) => props.imageUrl}') no-repeat top left;
    background-size: cover;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding: 24px 0 51px;
  }
`;

export { OuterWrapper, Wrapper };
